module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Gray - Selected.1bf55ce2.png";